module.exports = __webpack_public_path__ + "img/solution-big.d5c1ffe8.png";